import { getDefaultFormats } from "../../formats";
import { CustomFormats } from "react-intl";

import "../../polyfill-intl/locales/nb";

export const locales = ["nb-NO"];
export const name = "Brage";
export const legalName = name;
export const currency = "NOK";

export const getFormats = (locale: string): CustomFormats =>
	getDefaultFormats(currency);

export const getMessages = async (language: string) => {
	const defaultMessages = {
		"tenant.name": name,
		"tenant.legal_name": legalName
	};

	try {
		const messageOverrides = (
			await import(
				/* webpackInclude: /\.json$/, webpackMode: "eager", webpackChunkName: "tenants/brage/[request]" */
				`./translations/${language.toLowerCase()}`
			)
		).default;

		return {
			...defaultMessages,
			...messageOverrides
		};
	} catch (e: any) {}
	return defaultMessages;
};
